import React from 'react';
import "./Home.css";
import Typewriter from 'typewriter-effect';
import MyCv from "./a.jpg";
import { Link } from "react-scroll";
import Fade from 'react-reveal/Fade';
const Home = () => {
  return (
    <div className="container-fluid home" id="home">

      <div className="container home-content">
        <Fade right>

          <h1> Hi I'm Nandan Singh</h1>
          <h3   >
            <Typewriter
              options={{
                strings: ['Full Stack Developer', 'MERN Stack Developer', 'Software Developer', 'Backend Developer'],
                autoStart: true,
                loop: true,
                delay: 5
              }}
            />
          </h3></Fade>
        <Fade bottom>
      
          <div className="button-for-action">
          <Link to="contactsection">
            <div className="hire-me-button" >
          
              Hire Me
            </div></Link>
            <div className="get-resume-button">
              <a href={MyCv} download="Nandan_cv">
                Get Resume
              </a>
            </div> 
          </div>
         
        </Fade>
      </div>
    </div>
  )
};
export default Home;